import { List as ChakraList, OrderedList } from '@chakra-ui/react';
import { CoreBlock } from '../../types';

interface CoreListProps {
  block: CoreBlock & {
    attrs: CoreBlock['attrs'] & {
      ordered?: boolean;
      start?: number;
      reversed?: boolean;
    };
  };
  renderBlocks: (block: CoreBlock, i: number) => JSX.Element;
}

const CoreList: React.FC<CoreListProps> = ({ block, renderBlocks }) => {
  const { ordered } = block.attrs || {};

  const List = ordered ? OrderedList : ChakraList;

  return (
    <List listStyleType={ordered ? 'decimal' : 'inherit'} textStyle="lg">
      {block.innerBlocks?.map(renderBlocks)}
    </List>
  );
};
export default CoreList;
